import React, { useState } from 'react';
import ForgotPasswordForm from 'src/pages/Login/forms/ForgotPasswordForm';
import ForgotPasswordConfirmForm from 'src/pages/Login/forms/ForgotPasswordConfirmForm';

type Form = 'FORGOT_PASSWORD' | 'FORGOT_PASSWORD_CONFIRM';

const ForgotPasswordPage: React.FC = () => {
  const [currentForm, setCurrentForm] = useState<Form>('FORGOT_PASSWORD');
  const [currentUsername, setCurrentUsername] = useState<string | undefined>();

  const handleFormComplete = (username: string) => {
    setCurrentUsername(username);
    setCurrentForm('FORGOT_PASSWORD_CONFIRM');
  };

  const handleResetForm = () => {
    setCurrentForm('FORGOT_PASSWORD');
  };

  return (
    <>
      {currentForm === 'FORGOT_PASSWORD' && <ForgotPasswordForm onFormComplete={handleFormComplete} />}
      {currentForm === 'FORGOT_PASSWORD_CONFIRM' && <ForgotPasswordConfirmForm username={currentUsername} onResetForm={handleResetForm} />}
    </>
  );
};

export default ForgotPasswordPage;
